import { render, staticRenderFns } from "./registerForm.vue?vue&type=template&id=175bb098&scoped=true&"
import script from "./registerForm.vue?vue&type=script&lang=ts&"
export * from "./registerForm.vue?vue&type=script&lang=ts&"
import style0 from "./registerForm.vue?vue&type=style&index=0&id=175bb098&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175bb098",
  null
  
)

export default component.exports